export const getTaskMetadatasByVersion = /* GraphQL */ `
  query TaskMetadatasByVersion(
    $version: String
    $sortDirection: ModelSortDirection
    $filter: ModelTaskMetadataFilterInput
    $limit: Int
    $nextToken: String
  ) {
    taskMetadatasByVersion(
      version: $version
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        version
        product
        batch
        batchName
        versionProductBatch
        args {
          required
          default
          display
          order
          option
          type
          delimiter
          isMultiple
          isOutputFile
          isInputFile
          isSecret
          isResolvable
          hints {
            language
            hint
          }
          labels {
            language
            label
          }
          sampleInput
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const listTaskMetadatasWithDetails = /* GraphQL */ `
  query ListTaskMetadatas(
    $versionProductBatch: String
    $filter: ModelTaskMetadataFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listTaskMetadatas(
      versionProductBatch: $versionProductBatch
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        version
        product
        batch
        batchName
        versionProductBatch
        args {
          required
          default
          display
          order
          option
          type
          delimiter
          isMultiple
          isOutputFile
          isInputFile
          isSecret
          isResolvable
          hints {
            language
            hint
          }
          labels {
            language
            label
          }
          sampleInput
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
